// Generated by purs version 0.15.4
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
var P90 = /* #__PURE__ */ (function () {
    function P90() {

    };
    P90.value = new P90();
    return P90;
})();
var P95 = /* #__PURE__ */ (function () {
    function P95() {

    };
    P95.value = new P95();
    return P95;
})();
var P99 = /* #__PURE__ */ (function () {
    function P99() {

    };
    P99.value = new P99();
    return P99;
})();
var P999 = /* #__PURE__ */ (function () {
    function P999() {

    };
    P999.value = new P999();
    return P999;
})();
var eqInterval = {
    eq: function (x) {
        return function (y) {
            if (x instanceof P90 && y instanceof P90) {
                return true;
            };
            if (x instanceof P95 && y instanceof P95) {
                return true;
            };
            if (x instanceof P99 && y instanceof P99) {
                return true;
            };
            if (x instanceof P999 && y instanceof P999) {
                return true;
            };
            return false;
        };
    }
};
var ordInterval = {
    compare: function (x) {
        return function (y) {
            if (x instanceof P90 && y instanceof P90) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof P90) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof P90) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof P95 && y instanceof P95) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof P95) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof P95) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof P99 && y instanceof P99) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof P99) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof P99) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof P999 && y instanceof P999) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at PartyCarlo.Data.Result (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqInterval;
    }
};
var enumInterval = {
    succ: function (v) {
        if (v instanceof P90) {
            return new Data_Maybe.Just(P95.value);
        };
        if (v instanceof P95) {
            return new Data_Maybe.Just(P99.value);
        };
        if (v instanceof P99) {
            return new Data_Maybe.Just(P999.value);
        };
        if (v instanceof P999) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at PartyCarlo.Data.Result (line 22, column 1 - line 31, column 25): " + [ v.constructor.name ]);
    },
    pred: function (v) {
        if (v instanceof P90) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof P95) {
            return new Data_Maybe.Just(P90.value);
        };
        if (v instanceof P99) {
            return new Data_Maybe.Just(P95.value);
        };
        if (v instanceof P999) {
            return new Data_Maybe.Just(P99.value);
        };
        throw new Error("Failed pattern match at PartyCarlo.Data.Result (line 22, column 1 - line 31, column 25): " + [ v.constructor.name ]);
    },
    Ord0: function () {
        return ordInterval;
    }
};
var displayInterval = {
    display: function (v) {
        if (v instanceof P90) {
            return "90%";
        };
        if (v instanceof P95) {
            return "95%";
        };
        if (v instanceof P99) {
            return "99%";
        };
        if (v instanceof P999) {
            return "99.9%";
        };
        throw new Error("Failed pattern match at PartyCarlo.Data.Result (line 51, column 1 - line 55, column 27): " + [ v.constructor.name ]);
    }
};
var boundedInterval = /* #__PURE__ */ (function () {
    return {
        top: P999.value,
        bottom: P90.value,
        Ord0: function () {
            return ordInterval;
        }
    };
})();
var boundedEnumInterval = {
    cardinality: 4,
    toEnum: function (v) {
        if (v === 0) {
            return new Data_Maybe.Just(P90.value);
        };
        if (v === 1) {
            return new Data_Maybe.Just(P95.value);
        };
        if (v === 2) {
            return new Data_Maybe.Just(P99.value);
        };
        if (v === 3) {
            return new Data_Maybe.Just(P999.value);
        };
        return Data_Maybe.Nothing.value;
    },
    fromEnum: function (v) {
        if (v instanceof P90) {
            return 0;
        };
        if (v instanceof P95) {
            return 1;
        };
        if (v instanceof P99) {
            return 2;
        };
        if (v instanceof P999) {
            return 3;
        };
        throw new Error("Failed pattern match at PartyCarlo.Data.Result (line 37, column 1 - line 49, column 22): " + [ v.constructor.name ]);
    },
    Bounded0: function () {
        return boundedInterval;
    },
    Enum1: function () {
        return enumInterval;
    }
};
export {
    P90,
    P95,
    P99,
    P999,
    eqInterval,
    ordInterval,
    enumInterval,
    boundedInterval,
    boundedEnumInterval,
    displayInterval
};
